const header = {
  'links': {
    'industries': 'Industries',
    'solutions': 'Solutions',
  },
  'contact': 'Contact',
}

export default header
